import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, Typography, Paper, Divider, Hidden } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { paths } from '../../config/router.config';
import { DateRangeBlackIcon, PackageIcon, ReNewIcon, SortIcon } from '../../components/CustomIcons';
import { formatDateToDDMMYYYYFrEpoch } from '../../utils/commons';
import CustomContent from '../../components/CustomContent';
import theme from '../../theme.css';
import { green, red } from '@mui/material/colors';
import classNames from 'classnames';
import SupportRequestTableView from '../support/SupportRequestTableView'
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil';
import { portalCfg } from '../../config';
import CustomDrawer from '../../components/CustomDrawer';

const defaultImage = portalCfg.publicPath + "/images/logo.png";

const useStyles = makeStyles((theme) => ({
    '@global': {
        "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            height: theme.spacing(0.5),
        },
        "*::-webkit-scrollbar-thumb": {
            background: theme.palette.background.onCard,
        },
        "*::-webkit-scrollbar-track": {
            background: theme.palette.background.primary
        },
    },
    paper_container: {
        backgroundColor: theme.palette.common.white + "!important",
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },

    },
    support_request: {
        width: '100%',
        overflow: 'auto',
        [theme.breakpoints.down('sm')]: {
            width: window.outerWidth - 25,
        },
        paddingBottom: theme.spacing(2),
    },
    fixedHeight: {
        height: 300,
        [theme.breakpoints.down('lg')]: {
            height: 400
        },
        [theme.breakpoints.down('sm')]: {
            height: "auto",
        },

    },
    image_welcome: {
        width: '100%',
        height: 250,
        objectFit: 'contain',
        [theme.breakpoints.down('lg')]: {
            height: 200
        },
    },
    paper_container_xm: {
        height: 138,
        backgroundColor: theme.palette.common.white + "!important",
    },
    green: {
        backgroundColor: green[500] + '!important',
        color: theme.palette.common.white + "!important",
    },
    red: {
        backgroundColor: red[500] + '!important',
        color: theme.palette.common.white + "!important",
    },
    blue: {
        backgroundColor: theme.palette.primary.main + '!important',
        color: theme.palette.common.white + "!important",
    },
    list: {
        padding: theme.spacing(2, 0),
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(2),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        // backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },
    sub_img: {
        display: 'flex',
        alignItems: 'center'
    },
    item_cover: {
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: theme.spacing(1),
        "& img": {
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5),
            objectFit: 'contain',
        }
    },
    status: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    sub_date: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // height: 100
    },
    button: {
        margin: theme.spacing(0, 0.5, 0.5, 0.5),
    },
}));

export default function HomeView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { contact, orderStatus, onContinuePayment, service_requests, periods, periodSelected, onChangeTab, subcriptions, currency, onGoToPage, onTerminate } = props;

    let isOpenserveContact = false;
    let isMetrofibreContact = false;
    const contactCustomFields = props.contact && props.contact.custom_fields ? props.contact.custom_fields : [];
    if (contactCustomFields.length > 0) {
        for (let i = 0; i < contactCustomFields.length; i++) {
            let contactCustomField = contactCustomFields[i];
            if (contactCustomField.key == 'provider_order' && contactCustomField.value == 'openserve') {
                isOpenserveContact = true;
            }
            if (contactCustomField.key == 'provider_order' && contactCustomField.value == 'metrofibre') {
                isMetrofibreContact = true;
            }
        }
    }

    return (
        <CustomContent>
            <Grid xs={12} item container direction={'row'} spacing={3}>
                <Grid xs={12} sm={12} md={12} lg={12} xl={6} item>
                    <Welcome
                        contact={contact}
                        orderStatus={orderStatus}
                        t={t}
                        showButtonReOrder={props.showButtonReOrder}
                        onContinuePayment={onContinuePayment}
                        onGetOrderExpire={props.onGetOrderExpire}
                        onContinueOrder={props.onContinueOrder}
                    />
                </Grid>
                {contact && contact.referral_code &&
                    <Grid xs={12} sm={12} md={12} lg={12} xl={6} item>
                        <Grid xs={12} item component={Paper} padding={4} className={classes.paper_container}>
                            <Grid xs={8} sm={8} md={10} item >
                                <Typography marginBottom={1} variant='body2'>{t('refer_a_friend')}</Typography>
                                <Divider />
                            </Grid>
                            <Grid xs={12} item container direction="row" spacing={2} marginTop={0.5} paddingX={1}>
                                <Grid item>
                                    <Typography variant='body2'>{t('referral_code')}:</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body2' style={{ color: theme.palette.primary.main }}>{contact?.referral_code}</Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                }
            </Grid>
            <Grid xs={12} item container direction={'row'} spacing={3} marginTop={3}>
                <Grid item xs={12} lg={6}>
                    <SubscriptionPreview
                        t={t}
                        classes={classes}
                        periods={periods}
                        periodSelected={periodSelected}
                        subcriptions={subcriptions}
                        currency={currency}
                        onChangeTab={onChangeTab}
                        onGoToPage={onGoToPage}
                        onSwarpService={props.onSwarpService}
                        onTerminate={onTerminate}
                        orderStatus={orderStatus}
                        onChangeBillingDay={props.onChangeBillingDay}
                        isOpenserveContact={isOpenserveContact}
                        isMetrofibreContact={isMetrofibreContact}
                    />
                </Grid>
                <Grid item xs={12} lg={6} className={classes.support_request}>
                    <SupportRequest
                        supports={props.supports}
                        service_requests={service_requests}
                        onGoToPage={onGoToPage}
                    />
                </Grid>
            </Grid>
        </CustomContent>
    )
}

function Welcome(props) {
    const classes = useStyles();
    const { contact, t, orderStatus, onContinuePayment, showButtonReOrder, onContinueOrder } = props;
    console.log("props===", props);
    let name = contact ? contact.first_name + " " + contact.last_name : null;
    return (
        <Grid xs={12} item component={Paper} className={classNames(classes.paper_container, classes.fixedHeight)}>
            <Grid xs={12} item container direction={"row"} padding={4}>
                <Hidden lgUp>
                    <Grid xs={12} sm={12} md={12} lg={6} item>
                        <img src={portalCfg.publicPath + "/images/welcome.jpg"} className={classes.image_welcome} />
                    </Grid>
                </Hidden>
                <Grid xs={12} sm={12} md={12} lg={6} item>
                    <Typography variant='h4'>Hello, {name}</Typography>
                    <Box marginTop={3}>
                        <Typography variant='body'>{t('welcome_desc')}</Typography>
                    </Box>
                    <Grid item xs={12} marginTop={2}>
                        {orderStatus && orderStatus.productType == 'vuma_reach' && <Grid item xs={12}>
                            <Grid xs={12} item container>
                                {(orderStatus.status === 'PENDING_PAYMENT' || orderStatus.status === 'PAYMENT_FAIL' || orderStatus.status === 'CRM_ORDER_EXCEPTION') && <Button variant='contained' onClick={() => onContinuePayment()}>{t('btn_continue_payment')}</Button>}

                                {(orderStatus.status === 'VUMATEL_FAIL' || orderStatus.status === 'CRM_FAIL') && <Button variant='contained' onClick={() => props.onGetOrderExpire()}>{t('btn_reorder')}</Button>}
                                {showButtonReOrder && <Button variant='contained' onClick={() => props.onGetOrderExpire()}>{t('btn_reorder')}</Button>}
                            </Grid>
                        </Grid>}
                        {orderStatus && orderStatus.productType === 'vuma_core' && (orderStatus.status === 'PENDING_PAYMENT' || orderStatus.status === 'CRM_ORDER_EXCEPTION') && <Button variant='contained' onClick={() => onContinueOrder()}>{t('btn_continue_order')}</Button>}
                        {orderStatus && orderStatus.productType === 'openserve' && <>
                            {(orderStatus.status == 'PENDING_PAYMENT' || orderStatus.status === 'CRM_ORDER_EXCEPTION' || orderStatus.status == 'PAYMENT_FAIL') && <Button variant='contained' onClick={() => onContinuePayment()}>{t('btn_continue_payment')}</Button>}
                        </>}
                    </Grid>
                </Grid>
                <Hidden lgDown>
                    <Grid xs={12} sm={12} md={12} lg={6} item>
                        <img src={portalCfg.publicPath + "/images/welcome.jpg"} className={classes.image_welcome} />
                    </Grid>
                </Hidden>
            </Grid>
        </Grid >
    )
}

function RemainingData(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <>
            <Grid xs={12} item container direction={"row"} spacing={3} marginBottom={3}>
                <Grid xs={12} sm={12} md={12} lg={6} item>
                    <Grid item xs={12} component={Paper} className={classes.paper_container_xm} padding={4}>
                        <PackageIcon style={{ width: 64, height: 64 }} />
                        <Typography variant='body2'>S0000000713</Typography>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={6} item>
                    <Grid item xs={12} component={Paper} className={classNames(classes.paper_container_xm, classes.red)} padding={4}>
                        <Typography variant='body2'>{t('remaining_balance')}</Typography>
                        <Box marginTop={2}>
                            <Typography variant='h4'>{'_ GB'}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={12} item container direction={"row"} spacing={3}>
                <Grid xs={12} sm={12} md={12} lg={6} item>
                    <Grid item xs={12} component={Paper} className={classNames(classes.paper_container_xm, classes.green)} padding={4}>
                        <Typography variant='body2'>{t('anytime_data')}</Typography>
                        <Box marginTop={2}>
                            <Typography variant='h4'>{'_ GB'}</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={6} item>
                    <Grid item xs={12} component={Paper} className={classNames(classes.paper_container_xm, classes.blue)} padding={4}>
                        <Typography variant='body2'>{t('nighttime_data')}</Typography>
                        <Box marginTop={2}>
                            <Typography variant='h4'>{'_ GB'}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

function SubscriptionPreview(props) {
    const { classes, t, periods, periodSelected, isOpenserveContact, subcriptions, currency, onGoToPage, onTerminate, orderStatus ,isMetrofibreContact} = props;
    return (
        <Grid xs={12} item component={Paper} padding={4} className={classes.paper_container}>
            <Grid xs={12} item container direction={"row"} marginBottom={2}>
                <Grid xs={8} sm={8} md={10} item>
                    <Typography variant='body2'>{t('subscription_preview')}</Typography>
                    <Typography variant='caption'>{t('subscription_preview_desc')}</Typography>
                </Grid>
                <Grid xs={4} sm={4} md={2} item>
                    <Grid xs={12} item container justifyContent={'flex-end'}>
                        <Button size={'small'} variant='contained' onClick={() => onGoToPage(paths.subcriptions)}>{t('btn_more')}</Button>
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            {/* <Grid item xs={12} container alignItems='center'>
                {periods && periods.length > 0 && periods.map((period, index) => {
                    console.log("periodSelected == period: ", periodSelected === period);
                    return (
                        <Box key={index}>
                            <Button color={periodSelected === period ? 'primary' : 'info'} onClick={() => onChangeTab(period)}>
                                {period === 1 ? t('monthly') : period + t('month_title')}
                            </Button>
                        </Box>
                    );
                })}
            </Grid> */}
            <Grid xs={12} item className={classes.list}>
                {subcriptions && subcriptions.length > 0 &&
                    <Grid xs={12} item container className={classes.list}>
                        {subcriptions.map((item, idx) => (
                            <SubcriptionItem
                                key={idx}
                                t={t}
                                classes={classes}
                                item={item}
                                currency={currency}
                                onRecurringPayment={props.onRecurringPayment}
                                onSwarpService={props.onSwarpService}
                                onTerminate={onTerminate}
                                orderStatus={orderStatus}
                                onChangeBillingDay={props.onChangeBillingDay}
                                isOpenserveContact={isOpenserveContact}
                                isMetrofibreContact={isMetrofibreContact}
                            />
                        ))}
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

function SubcriptionItem(props) {
    const { classes, t, item, currency, isOpenserveContact,isMetrofibreContact } = props;
    // console.log("AAA item sub===", item);
    let images = dataUtil.getImageByUsageType(item.service.product ? item.service.product.creatives : null, usage_type.product_item);
    let productType = item.service && item.service.product && item.service.product.type ? item.service.product.type : null;
    console.log("AAA productType===", productType);
    let imageSub = '/images/logo.png';
    if (images && images.length > 0) {
        imageSub = images[0].uri;
    }
    let showTerminate = true;
    let showChangeBillingDay = false;
    if (productType && productType.name == 'VC') {
        showTerminate = false;
        showChangeBillingDay = true;
    }
    return (
        <Grid xs={12} item container className={classes.container}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container style={{ alignItems: "center" }}>
                    <Grid item xs={9}>
                        <Grid item xs={12} className={classes.sub_img}>
                            <Grid item className={classes.item_cover}>
                                <img src={imageSub} alt="Image Service" />
                            </Grid>
                            <Typography variant='subtitle2' style={{ marginLeft: 10 }}>{item.service && item.service.product ? item.service.product.name : ""}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: 'right' }}>
                        <Typography variant='subtitle2' style={{ marginLeft: 10 }}><strong>{currency}{item.service && item.service.product && item.service.product.price ? item.service.product.price.toFixed(2) : "0.00"}</strong></Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.status}>
                    <Button size={"small"} variant='outlined'>{item.service.life_cycle_state}</Button>
                    {item.service.removed_on&& <Button sx={{ml:1}} size={"small"} variant='outlined'>Pending Changes</Button>}
                    {item.service.terms && item.service.terms.in_contract &&
                        <Button size={"small"}>{t('in_contract')}</Button>}

                    {item.service.trial_period && item.service.trial_period.trial_state === "IN_TRIAL" &&
                        <Button size={"small"}>{t('in_trial')}</Button>}
                </Grid>
                <Grid item container className={classes.sub_date}>
                    {item.service.terms && item.service.terms.auto_renew &&
                        <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                            <ReNewIcon />
                            <Grid item style={{ paddingLeft: 10 }}>
                                <Typography variant='subtitle2'>{t('auto_renew')}</Typography>
                                <Typography variant='body2'>{item.service.terms.contract_period && item.service.terms.contract_period.end_date ? formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date) : ''}</Typography>
                            </Grid>
                        </Grid>
                    }
                    {item.service.terms.in_contract
                        && item.service.terms.contract_period
                        && item.service.terms.contract_period.start_date
                        && item.service.terms.contract_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typography variant='subtitle2'> {t('sub_contract_period') + " "} </Typography>
                                    <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service.trial_period
                        && item.service.trial_period.end_date
                        && item.service.trial_period.start_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typography variant='subtitle2'>{t('sub_trial_period')}</Typography>
                                    <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.trial_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.trial_period.end_date)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                <Grid item xs={12} container justifyContent='center' alignItems='center'>
                    <Grid item xs={12}>
                        {item.service.added_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('added_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.added_on)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.service.removed_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('removed_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.removed_on)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.service.firts_activated_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('firts_activated_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.firts_activated_on)}</Typography>
                            </Grid>
                        </Grid>}
                    </Grid>
                    {(!isOpenserveContact && !isMetrofibreContact) && item.service.life_cycle_state === 'EFFECTIVE' && <Grid item xs={12} style={{ marginTop: 10 }}>
                        <Grid item xs={12} textAlign={'right'}>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                    props.onSwarpService(item)
                                }}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_upgrade_downgrade')}
                            </Button>
                            {showTerminate && <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onTerminate(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_terminate')}
                            </Button>}
                           {showChangeBillingDay && <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onChangeBillingDay(item)}
                            >
                                {t('btn_change_billing_day')}
                            </Button>}
                        </Grid>
                    </Grid>}
                    {(isOpenserveContact || isMetrofibreContact) && item.service.life_cycle_state === 'EFFECTIVE' &&<Grid item xs={12}>
                        <Grid item xs={12} textAlign={'right'}>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onSwarpService(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_upgrade_downgrade')}
                            </Button>
                            {isOpenserveContact&&
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onCancel(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_cancel')}
                            </Button>}
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>
    );
}

function SupportRequest(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { service_requests, onGoToPage } = props;
    console.log("service_requests==", service_requests);
    return (
        <Grid xs={12} item component={Paper} padding={4} className={classes.paper_container}>
            <Grid xs={12} item container direction={"row"} marginBottom={2}>
                <Grid xs={6} sm={6} md={8} item>
                    <Typography variant='body2'>{t('support_request')}</Typography>
                </Grid>
                <Grid xs={6} sm={6} md={4} item>
                    <Grid xs={12} item container justifyContent={'flex-end'}>
                        <Button size={'small'} color="success" variant='contained' onClick={() => onGoToPage(paths.support_add)}>{t('btn_create')}</Button>
                        <Box marginLeft={1}>
                            <Button size={'small'} variant='contained' onClick={() => onGoToPage(paths.support)}>{t('btn_more')}</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            <SupportRequestTableView rows={service_requests} />
        </Grid>
    )
}

